import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import CodeMirror from 'react-codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/scroll/annotatescrollbar'
import 'codemirror/addon/search/search'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/jump-to-line'
import 'codemirror/addon/search/matchesonscrollbar'

import { Icon, Menu, Tab } from 'semantic-ui-react'

import sortBy from 'lodash/sortBy'
import reverse from 'lodash/reverse'
import uniqBy from 'lodash/uniqBy'

import moment from 'moment'

import TopiclesColumn from '../../probish/TopiclesColumn'
import { Article } from '../../probish/Article'
import { findGraphqlApikpFeedForProfile } from '../../all_cards/aufschaltung.js'
import { datePrimaryFormat } from '../../util/datetime'

const AbortController = window.AbortController

class FeedContentBrowser extends Component {
  constructor (props) {
    super(props)
    this.state = this._getInitialState()
    this.setState({timerId: null})

    // Setup abort controller
    this._createAbortController()
  }

  _createAbortController () {
    this.abortController = new AbortController()
    this.abortSignal = this.abortController.signal
    //this.abortSignal.addEventListener('abort', () => {
    //  console.log('$$$$$ aborted!')
    //})
  }

  _getInitialState () {
    /** Initial Object for the state is returned.
     */
    const { context } = this.props
    return {
      isJsonFeed: context && context.navigation.api === 'jsonfeed',
      topicles: [],
      selectedTopicle: null,
      gql_limit: 10,
      gql_after: 0,
      gql_hasMore: true,
      gql_endpoint_url: ''
    }
  }

  async _refetchData () {
    // Cancel the previous request before new refetch
    this.abortController.abort()
    this._createAbortController()

    // Reset state first
    await this.setStateAsync(this._getInitialState())
    // Refetch content
    await this.fetch_topicle_content()
    // Select last topicle as default
    const { topicles } = this.state
    this.handleSelectedTopicle(topicles.length === 0 ? null : topicles[0])
  }

  async componentDidMount() {
    await this._refetchData()
  }

  async componentWillReceiveProps(props) {
    if (this.props.pollForFeedContent !== props.pollForFeedContent) {
      if (props.pollForFeedContent) this.startTimer()
    }
    if (this.props !== props) {
      this.props = props
      await this._refetchData()
    }
  }

  async fetch_topicle_content() {
    const { context } = this.props
    // Check whether the browser should show 'jsonfeed' or internal
    // api 'graphqlapikp' content
    const { isJsonFeed } = this.state
    if (isJsonFeed) {
      const { feed } = this.props
      if (feed && feed.is_activated && feed.feed_url) {
        await this._fetch_jsonfeed_content(feed.feed_url)
      } else {
        await this.setStateAsync({
            jsonfeed: {entries: []}
          })
      }
    } else {
      const feed = findGraphqlApikpFeedForProfile(context)
      if (feed && feed.graphql_endpoint_url) {
        await this._fetch_graphql_content(feed.graphql_endpoint_url)
      }
    }
    await this.setStateAsync({ last_fetched: moment().utc() })
  }

  async fetch_more_graphql_content () {
    const { gql_endpoint_url } = this.state
    await this._fetch_graphql_content(gql_endpoint_url, false)
  }

  async _fetch_graphql_content(gql_endpoint_url, show_loading=true) {
    let graphql_topicles
    const { gql_limit, gql_after } = this.state
    try {
      if (show_loading) await this.setStateAsync({ loading: true })
      const resp = await fetch(
        gql_endpoint_url,
        {
          signal: this.abortSignal,
          method: 'post',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            query: `{
              topicles (limit: ${gql_limit}, after: "${gql_after}") {
                nextToken
                items {
                  id
                  urn
                  version
                  updated
                  title
                  tags
                  content
                  media_groups {
                    title
                    urn
                    description
                    creditline
                    medium
                    contents {
                      size
                      url
                    }
                  }
                }
              }
            }`})
        })
        graphql_topicles = await resp.json()
    } catch(e) {
      console.error(e)
      graphql_topicles = null
      if (show_loading) await this.setStateAsync({ loading: false })
      return
    }
    if (graphql_topicles.errors) {
      graphql_topicles = null
      if (show_loading) await this.setStateAsync({ loading: false })
      return
    }
    const new_nextToken = graphql_topicles.data.topicles.nextToken
    await this.setStateAsync({
      gql_topicles: graphql_topicles.data.topicles,
      gql_endpoint_url: gql_endpoint_url,
      gql_hasMore: (gql_after === new_nextToken ? false : true),
      gql_after: new_nextToken
    })
    // Update topicles
    if (gql_after !== new_nextToken) {
      const { topicles } = this.state
      // Make sure to have no duplicate topicles in merged list (check against
      // urn and updated key)
      const mergedTopicles = uniqBy([...topicles, ...this.getTopicles()], t => [t.urn, t.updated].join())
      await this.setStateAsync({
        topicles: mergedTopicles
      })
    }
    if (show_loading) await this.setStateAsync({ loading: false })
  }

  async _fetch_jsonfeed_content(feed_url) {
    let jsonfeed
    try {
      await this.setStateAsync({ loading: true })
      const resp = await fetch(feed_url,
        {
          method: 'get',
          headers: {'cache-control': 'no-cache'}
        })
      jsonfeed = await resp.json()
    } catch(e) {
      console.error(e)
      jsonfeed = null
    }
    await this.setStateAsync({
      jsonfeed: jsonfeed,
      feed_url: feed_url,
      loading: false
    })
    await this.setStateAsync({topicles: this.getTopicles()})
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  handleSelectedTopicle = (topicle) => {
    this.setState({selectedTopicle: topicle})
  }

  getTopicles = () => {
    /**
     * Depending on the feed type (jsonfeed/graphqlapikp) the topicles are
     * represented differently.
     */
    const { isJsonFeed } = this.state

    let topicles
    if (isJsonFeed) {
      const { jsonfeed } = this.state
      topicles = (jsonfeed && jsonfeed.entries) || []
      // little hack, ensure feed is time-reverse sorted
      topicles = reverse(sortBy(topicles, t => moment(t.version_created || t.versioncreated)))
    } else {
      const { gql_topicles } = this.state
      topicles = (gql_topicles && gql_topicles.items) || []
    }

    return topicles
  }

  setTimeoutAsync (pollForFeed, timeout = 5000) {
    return new Promise((resolve) => {
      this.setState(
        {timerId: setTimeout(() => this.timedCount(), timeout)})
      pollForFeed()
      resolve()
    })
  }

  startTimer = () => {
    this.timedCount()
  }

  async timedCount () {
    await this.setTimeoutAsync(async () => {
      await this._refetchData()
      const { topicles } = this.state
      const { feed } = this.props
      const isActivated = feed.is_activated
      const hasTopicles = !!(topicles && topicles.length)
      if (isActivated) {
        if (hasTopicles) {
          this.stopTimer()
          return
        }
      } else {
        if (!hasTopicles) {
          this.stopTimer()
          return
        }
      }
    }, 5000)
  }

  stopTimer = () => {
    clearTimeout(this.state.timerId)
    this.props.onStopFeedPolling(this.props.feed)
  }

  render () {
    const { last_fetched, isJsonFeed } = this.state
    const updated = last_fetched && last_fetched.format()
    const articleTitle = 'Artikel'

    const panes = [
      {
        menuItem: 'JSON',
        render: () => this.render_json()
      },
      {
        menuItem: (
          <Menu.Item key={articleTitle}>
            <Trans>
              {articleTitle}
            </Trans>
          </Menu.Item>
        ),
        render: () => this.render_content()
      },
    ]

    return (
      <div className='ProfileContentBrowser'>
        <div className='ProfileContentBrowser-currentdate-and-refresh'>
          <Trans>Stand</Trans> <span style={{fontWeight:'bold', marginRight: '1em'}}>{datePrimaryFormat(updated)}</span>
          <Icon name='refresh' onClick={async () => await this._refetchData()} />
        </div>

        { isJsonFeed ? (
          <Tab menu={{secondary: true, pointing: true, className: 'tab-wrapped'}} panes={panes} />
          ) : (
            this.render_content()
          )
        }
      </div>
    )
  }

  render_json () {
    const { jsonfeed, feed_url, loading, last_fetched } = this.state
    const feed_content = jsonfeed ? JSON.stringify(jsonfeed, null, 2) : ' '

    return (
      <Tab.Pane loading={loading} className='ProfileContentBrowser-tab' key={last_fetched}>
        <CodeMirror {...{value: feed_content,
          key: feed_url,
          className: 'codemirror-json',
          options: {
            mode: 'javascript',
            readOnly: true,
            lineWrapping: true,
            lineNumbers: true,
            foldGutter: true,
            lint: true,
            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
            theme: 'ttcn',
            extraKeys: {
              'Ctrl-F': function(cm) {
                cm.execCommand('findPersistentNext')
              }
            }
          }}} />
      </Tab.Pane>
    )
  }

  render_content () {
    const { loading, last_fetched } = this.state
    return (
      <Tab.Pane loading={loading} className='ProfileContentBrowser-tab' key={last_fetched}>
        {
          this.render_content_without_pane()
        }
      </Tab.Pane>
    )
  }

  render_content_without_pane () {
    const { isJsonFeed, topicles, selectedTopicle } = this.state

    const _topicle = selectedTopicle && {...selectedTopicle,
      content: (selectedTopicle.content || selectedTopicle.content_html_body ||
                selectedTopicle.article_html)}

    return (
        <div className='ProfileContentBrowser-article-tab-content'>
          <TopiclesColumn
            topicles={topicles}
            selectedTopicle={_topicle}
            onTopicleSelected={this.handleSelectedTopicle}
            infiniteScroll={isJsonFeed ? false : true}
            hasMore={this.state.gql_hasMore}
            onFetchMore={this.fetch_more_graphql_content.bind(this)} />

          <div className='dummy-article'>
            <Article topicle={_topicle || {}}
              detail_topicle={_topicle}
              loading={false} />
          </div>
        </div>
    )
  }
}

export { FeedContentBrowser }



// WEBPACK FOOTER //
// ./src/components/cards/FeedContentBrowser.js